import React, { useContext, useEffect, useState } from "react";
import "./Header.css";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import MenuIcon from "@mui/icons-material/Menu";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { ActionTooltip } from "../common/TableUI/TableUI";
import { Context } from "../../utils/context";
import { useLocation, useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cookies from "js-cookie";
import { Button, InputGroup, Offcanvas } from "react-bootstrap";
import { Form } from "react-bootstrap";
import MobileSidebar from "../Sidebar/MobileSidebar";
import ViewOffCanvance from "../myProfile/ViewOffCanvance";
import Logoutmodal from "../common/Logoutmodal/Logoutmodal";
import { Link } from "react-router-dom";
import {
  DASHBOARD_PATH,
  NOTIFICATIONS_SECTION_ID,
} from "../DashBoard/AdvanceDashboard/dashboardSections";
import { RoleId } from "../../utils/common";
import RangeModel from "../common/RangeModel";
import Sidebar from "../Sidebar/Sidebar";
import PasswordChange from "../common/password_change/Passwordchange";
library.add(fas);

/* Total notification count from the same endpoint the dashboard lists.
   A paginated response reports `total`; a plain list is counted. */
const readNotificationTotal = (response) => {
  if (!response?.success) return null;
  const payload = response?.data;
  if (typeof payload?.total === "number") return payload.total;
  if (Array.isArray(payload?.data)) return payload.data.length;
  if (Array.isArray(payload)) return payload.length;
  return null;
};

function NotificationBell({ count }) {
  const navigate = useNavigate();
  const location = useLocation();
  const hasCount = typeof count === "number" && count > 0;
  const label = hasCount
    ? `${count} notification${count === 1 ? "" : "s"}`
    : "No new notifications";

  /* Opens the dashboard and asks it to scroll to its Notifications card.
     On the dashboard itself the history entry is replaced, so the page is
     not reloaded and Back still leaves the dashboard. Modified clicks
     (new tab / window) keep the plain link behaviour. */
  const openNotifications = (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    event.preventDefault();
    navigate(DASHBOARD_PATH, {
      state: { scrollTo: NOTIFICATIONS_SECTION_ID },
      replace: location.pathname === DASHBOARD_PATH,
    });
  };

  return (
    <div className="search-area icon header-notif">
      <ActionTooltip title={label} placement="bottom">
        <Link
          to={DASHBOARD_PATH}
          onClick={openNotifications}
          className="header-notif__link"
          aria-label={`Notifications: ${label}`}
        >
          <NotificationsNoneOutlinedIcon fontSize="inherit" className="power-icon" />
          {hasCount && (
            <span className="header-notif__badge" aria-hidden="true">
              {count > 99 ? "99+" : count}
            </span>
          )}
        </Link>
      </ActionTooltip>
    </div>
  );
}

// ({ title, link })
function Header({ title, props }) {
  const {
    setUserData,
    setUsertype,
    setSignin,
    usertype,
    isSidebarOpen,
    setSidebarOpen,
    toggleSidebar,
    getData,
    IMG_URL,
  } = useContext(Context);

  const navigate = useNavigate();

  const LogOut = async () => {
    Cookies.remove("harvestera_admin_security", { path: "/" });
    await setUserData("");
    await setUsertype("");
    await setSignin(false);
    navigate("/");
  };

  const [user, setUser] = useState({});
  const [store, setStore] = useState({});
  const GetUserData = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
      if (response?.data?.role_id === RoleId.Vendor) {
        const res = await getData(`/admin/store/my-store`);
        await setStore(res?.data);
      }
    }
  };
  useEffect(() => {
    GetUserData();
  }, []);

  const [notificationCount, setNotificationCount] = useState(null);
  useEffect(() => {
    let active = true;
    getData(`/admin/notification?page=1`).then((response) => {
      if (active) setNotificationCount(readNotificationTotal(response));
    });
    return () => {
      active = false;
    };
  }, []);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [view, setView] = useState(false);
  const [viewRangeModel, setViewRangeModel] = useState(false);
  const handleViewClose = () => setView(false);
  const handleViewshow = async () => {
    await setView(true);
  };

  const [modalshow, setmodalshow] = useState(false);


  const [password, setPassword] = useState(false);
  const handleshow = async () => {
    await setPassword(true);
  };

  return (
    <>
      <section className="header">
        <Navbar expand="md" className="bg-body-tertiary">
          <Navbar.Brand>
            <div className="header-text">
              <div className="desktop-bar-btnnn">
                <div className="bars d-flex" onClick={toggleSidebar}>
                  <ActionTooltip title="Toggle sidebar" placement="bottom">
                    <MenuIcon fontSize="inherit" className="header-menu-icon" aria-label="Toggle sidebar" />
                  </ActionTooltip>
                  <h1>{title}</h1>
                </div>
              </div>
              {user?.role_id === RoleId.Vendor && (
                <Button
                  variant="success"
                  onClick={() => setViewRangeModel(true)}
                >
                  Delivery Range : - {store?.delivery_range} KM
                </Button>
              )}
              <div className="mobile-view-bar">
                <ActionTooltip title="Open menu" placement="bottom">
                <div className="bars" onClick={handleShow} role="button" aria-label="Open menu">
                  <MenuIcon fontSize="inherit" className="header-menu-icon" />
                </div>
                </ActionTooltip>
                <Offcanvas
                  show={show}
                  onHide={handleClose}
                  backdrop="static"
                  style={{ width: "80%" }}
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title className="mobdshhide">DashBoard</Offcanvas.Title>
                    <Link to="/advanceDashboard"><img className="moblogefwfgj" src={process.env.PUBLIC_URL + '/assets/images/logo.png'} /></Link>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    {/* <MobileSidebar /> */}
                    <Sidebar />
                  </Offcanvas.Body>
                </Offcanvas>
              </div>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />



          <div className="mobview_loglogo">
            <div className="logodiv">
              <img className="logo" src={process.env.PUBLIC_URL + '/assets/images/logo.png'} />
            </div>
          </div>

          <div className="mobview_loglogo">
            <div className="icon dropdown">
              <ActionTooltip title="Account & log out" placement="bottom">
                <div
                  className="text-center dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  role="button"
                  aria-label="Account and log out"
                >
                  <PowerSettingsNewIcon fontSize="inherit" className="power-icon" />
                </div>
              </ActionTooltip>

              <ul className="dropdown-menu">
                <div className="blue-bg">
                  <div className="text-center">
                    <AccountCircleOutlinedIcon className="floguser" sx={{ fontSize: 28 }} />
                  </div>

                  <div
                    className="icon dropdown"
                    style={{ textAlign: "center" }}
                  >
                    <p className="mb-0 logout_content_sec">
                      {user?.first_name}
                    </p>
                    <p className="logout_content_secccc">{user?.type}</p>
                  </div>
                </div>

                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    
                  >
                    <button onClick={() => setmodalshow(true)} className="logout-btnnn"> Log out</button>
                  </a>
                </li>
              </ul>
            </div>
          </div>

              <div className="ms-auto d-flex  align-items-center">
              <button
              className="btn btn-dark"
              style={{
                width: "fit-content",
                fontSize: "14px",
              }}
              onClick={handleshow}
            >
              <FontAwesomeIcon
                icon="fa-solid fa-shield-halved"
                className="power-icon icon me-2"
              />
              Change Password
            </button>


          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <div className="header-icons">
                <NotificationBell count={notificationCount} />
                {user?.role_id === RoleId.Vendor && (
                  <>
                    <div className="search-area icon">
                      <ActionTooltip title="Download QR code" placement="bottom">
                      <Link
                        to={IMG_URL + '/' + store?.qr_code}
                        target="_blank"
                        download={IMG_URL + '/' + store?.qr_code}
                        rel="noopener noreferrer"
                        aria-label="Download QR code"
                      >
                        <QrCode2Icon fontSize="inherit" className="power-icon" />
                      </Link>
                      </ActionTooltip>
                    </div>
                    <div className="search-area icon">
                      <ActionTooltip title="Profile" placement="bottom">
                      <Link to="/profile" aria-label="Profile">
                        <PersonOutlinedIcon fontSize="inherit" className="power-icon" />
                      </Link>
                      </ActionTooltip>
                    </div>
                    <div className="search-area icon">
                      <ActionTooltip title="Wallet" placement="bottom">
                      <Link to="/my-wallet" aria-label="Wallet">
                        <AccountBalanceWalletOutlinedIcon fontSize="inherit" className="power-icon" />
                      </Link>
                      </ActionTooltip>
                    </div>
                  </>
                )}

                <div className="icon dropdown">
                  <ActionTooltip title="Account & log out" placement="bottom">
                    <div
                      className="text-center dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      role="button"
                      aria-label="Account and log out"
                    >
                      <PowerSettingsNewIcon fontSize="inherit" className="power-icon" />
                    </div>
                  </ActionTooltip>

                  <ul className="dropdown-menu">
                    <div className="blue-bg">
                      <div className="text-center">
                        <AccountCircleOutlinedIcon className="floguser" sx={{ fontSize: 28 }} />
                      </div>

                      <div
                        className="icon dropdown"
                        style={{ textAlign: "center" }}
                      >
                        <p className="mb-0 logout_content_sec">
                          {user?.first_name}
                        </p>
                        <p className="logout_content_secccc">{user?.type}</p>
                      </div>
                    </div>

                    <li>
                      <a
                        className="dropdown-item logout_btn_a"
                        href="#"
                        
                      >
                        <button onClick={() => setmodalshow(true)} className="logout-btnnn"> Log out</button>
                      </a>
                    </li>
                  </ul>
                </div>

                <p className="mb-0 logout_content">{user?.name}</p>
              </div>
            </Nav>
          </Navbar.Collapse>

          </div>


        </Navbar>

        <Logoutmodal
          show={modalshow}
          onHide={() => setmodalshow(false)}
          LogOut={LogOut}
        />
      </section>
      {view ? (
        <ViewOffCanvance
          handleClose={handleViewClose}
          setShow={setView}
          show={view}
          user_id={user?.id}
        />
      ) : (
        ""
      )}

      {viewRangeModel ? (
        <RangeModel
          handleClose={() => {
            setViewRangeModel(false);
            GetUserData();
          }}
          setShow={setViewRangeModel}
          show={viewRangeModel}
          user_id={user?.id}
          store={store}
        />
      ) : (
        ""
      )}


      {/* change password modal */}
      {password ? (
        <PasswordChange
          handleClose={handleClose}
          setShow={setPassword}
          show={password}
          user_id={user?.id}
          onHide={() => setPassword(false)}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default Header;
